export default __webpack_public_path__ + "static/media/169413449_119344280240094_1810795263236791857_n.e87deb85.jpg";